'use client';

import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { useTranslation } from 'react-i18next';

ChartJS.register(ArcElement, Tooltip, Legend);

export function DonutChart({ values, colors }) {
    const { t } = useTranslation();
    const data = {
        labels: [
            `${t('approveds')}`,
            `${t('pendingValidation')}`,
            `${t('Tests refusés')}`,
            `${t('unassigned')}`,
        ],
        datasets: [
            {
                data: values,
                backgroundColor: colors,
                borderWidth: 0,
            },
        ],
    };

    const options = {
        cutout: '75%',
        plugins: {
            legend: {
                display: false,
            },
        },
    };
    return (
        <div style={{ width: '200px' }}>
            <Doughnut data={data} options={options} />
        </div>
    );
}
